import { SpDropdownToggle } from 'components/shared/Dropdown';
import { FC, useCallback, useState } from 'react';
import { Dropdown, DropdownDivider, DropdownItem, DropdownMenu } from 'react-bootstrap';
import type { ProductCodeType } from 'state/secondaryMarket/productSearch';

type Props = Readonly<{
  isInternalUser: boolean;
  value: ProductCodeType;
  fullWidth?: boolean;
  onValueChanged: (value: ProductCodeType) => void;
}>;

export const CodeTypeSelector: FC<Props> = ({ value, onValueChanged, isInternalUser, fullWidth = false }) => {
  const onSelectCode = useCallback((code: ProductCodeType) => onValueChanged(code), [onValueChanged]);
  const [isOpened, setIsOpened] = useState(false);
  const toggle = useCallback(() => {
    if (isInternalUser) {
      setIsOpened(old => !old);
    }
  }, [isInternalUser]);
  return (
    <Dropdown show={isOpened} onToggle={toggle} drop="down" className={fullWidth ? 'w-100' : undefined}>
      <SpDropdownToggle variant="secondary" caret={isInternalUser} className={fullWidth ? 'w-100' : undefined}>
        <span data-e2e="search-type-dropdown-btn" className="text-uppercase">
          {value}
        </span>
      </SpDropdownToggle>

      <DropdownMenu className={fullWidth ? 'w-100' : ''}>
        <DropdownItem data-e2e="search-isin-dropdown-btn" onClick={_ => onSelectCode('ISIN')}>
          ISIN
        </DropdownItem>
        {isInternalUser && (
          <>
            <DropdownItem data-e2e="search-wkn-code-dropdown-btn" onClick={_ => onSelectCode('WKN')}>
              WKN
            </DropdownItem>
            <DropdownItem data-e2e="search-cusip-code-dropdown-btn" onClick={_ => onSelectCode('CUSIP')}>
              CUSIP
            </DropdownItem>
            <DropdownItem data-e2e="search-valoren-code-dropdown-btn" onClick={_ => onSelectCode('VALOREN')}>
              VALOREN
            </DropdownItem>

            <DropdownDivider />
            <DropdownItem data-e2e="search-file-code-dropdown-btn" onClick={_ => onSelectCode('File Code')}>
              File code
            </DropdownItem>
            <DropdownItem data-e2e="search-eliot-code-dropdown-btn" onClick={_ => onSelectCode('ELIOT')}>
              ELIOT
            </DropdownItem>
            <DropdownItem data-e2e="search-eliot-otc-code-dropdown-btn" onClick={_ => onSelectCode('ELIOT OTC')}>
              ELIOT OTC
            </DropdownItem>
            <DropdownItem data-e2e="search-xone-code-dropdown-btn" onClick={_ => onSelectCode('XONE')}>
              XONE
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};
